import { UserService } from 'app/services/user.service';
import { HeaderPopover } from './header.popover';
import { PopoverController, NavController, AlertController } from '@ionic/angular';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Capacitor } from '@capacitor/core';

const isNative = Capacitor.isNativePlatform();
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit
{
	@Input() loading: boolean = false;
	@Input() scrollTop: boolean = false;
	@Input() title: string;
	@Input() hideTitle: boolean = false;
	@Input() top: boolean = false;

	@Input() menu: boolean = true;


	@Input() add: boolean = false;
	@Output() addClick = new EventEmitter<any>();

	@Input() popover: boolean = false;
	@Output() popoverClick = new EventEmitter<any>();
	@Input() popoverIcon: string = "icon-mc_more"; //"icon-mc-three-dots";


	@Input() barcode: boolean = false;
	@Output() barcodeClick = new EventEmitter<any>();

	@Input() searchbar: boolean = false;
	@Input() searchbarTitle: string;
	@Output() searchbarClick = new EventEmitter<any>();
	// @Input() searchbarSearch: boolean = false;

	@Input() back: boolean = false;
	@Input() backHref: string = "/vehicles";
	@Input() close: boolean = false;

	@Input() edit: boolean = false;
	@Output() editClick = new EventEmitter<any>();
	@Input() export: boolean = false;
	@Output() exportClick = new EventEmitter<any>();
	@Input() logout: boolean = false;

	@Input() global: boolean = false;

	native: boolean = false;
	constructor(
		public popoverController: PopoverController,
		public navController: NavController,
		public userService: UserService,
		private alertController: AlertController
	)
	{ }

	ngOnInit()
	{
		this.native = isNative;
		if (!this.searchbarTitle)
		{
			this.searchbarTitle = "Search " + this.title.toLowerCase();
		}
		if (this.back || this.close)
		{
			this.menu = false;
		}
	}

	popoverDebouncing: boolean = false;
	async showPopover(ev: any)
	{
		if (this.popoverDebouncing) {
			console.error("popover is debouncing");
			return;
		}
		console.debug("popover debouncing");
		this.popoverDebouncing = true;

		var self = this;
		setTimeout(() =>
		{
			self.popoverDebouncing = false;
		}, 1000);

		this.popoverClick.emit(ev);
	}

	popoverActive: boolean = false;
	async showMCPopover(ev: any)
	{
		if (this.popoverActive) {
			console.error("popover is debouncing");
			return;
		}

		this.popoverActive = true;
		const popover = await this.popoverController.create({
			component: this.getPopoverComponent(),
			componentProps: ev,
			event: ev,
			translucent: true,
			cssClass: 'mc-menu-popover'
		});
		await popover.present();
		popover.onDidDismiss().then((data) =>
		{
			this.popoverDismissed(data);
			this.popoverActive = false;
		});

		setTimeout(() =>
		{
			this.popoverActive = false;
		}, 1000);
	}

	public getPopoverComponent(): any
	{
		return HeaderPopover;
	}

	public async popoverDismissed(data: any)
	{
		switch (data.data)
		{
			case 'sendToSupport':

				break;
			default:
				break;
		}
	}

	async showSearch(ev: any)
	{
		this.searchbarClick.emit(ev);
	}
	async showBarcode(ev: any)
	{
		this.barcodeClick.emit(ev);
	}
	async showAdd(ev: any)
	{
		this.addClick.emit(ev);
	}
	async doLogout(ev: any)
	{
		this.userService.confirmLogout();
	}
	async doEdit(ev: any)
	{
		this.editClick.emit(ev);
	}
	async doExport(ev: any)
	{
		this.exportClick.emit(ev);
	}
}
